const locale = {
  CHANGE_PASSWORD: 'Cambiar Contraseña',
};

export default locale;
